// ** Service
//import { getUserName } from "../../auth/LoginUser";
import { getUserName } from "../../auth/LoginUser";
import SecurityCenterServices from "../../services/SecurityCenterServices";

// ** useRef
const fetchUserGroup = (userGroupName) =>
  new Promise((resolve) => {
    const param = { USER_NAME: getUserName(), USER_GROUP_NAME: userGroupName };

    SecurityCenterServices.getUserGroupByUsernameAndLikeUserGroupName(param)
      .then((responseJson) => {
        resolve(responseJson.data.ResultOnDb || []);
      })
      .catch((error) => console.log(error));
  });

const hasExactUserGroup = (groups, userGroupName) => {
  const expectedGroupName = String(userGroupName || "").trim().toUpperCase();

  return (
    Array.isArray(groups) &&
    groups.some(
      (group) =>
        String(group.USER_GROUP_NAME || "").trim().toUpperCase() ===
        expectedGroupName
    )
  );
};

export { fetchUserGroup, hasExactUserGroup };
